import { Query } from '@varo/graphql-schema-types';
import UpsideOfferDetails from 'services/graphql/queries/UpsideOfferDetails.query';
import { useQuery } from 'urql';

const useUpsideOffersDetails = (
  merchantId: string,
  coordinates?: google.maps.LatLngLiteral,
  categoryName?: string,
) => {
  const hasValidCoordinates = (
    coords?: google.maps.LatLngLiteral,
  ): coords is google.maps.LatLngLiteral =>
    !!coords && Number.isFinite(coords.lat) && Number.isFinite(coords.lng);

  const paused = !merchantId || !hasValidCoordinates(coordinates);

  const location = hasValidCoordinates(coordinates)
    ? { latitude: coordinates.lat, longitude: coordinates.lng }
    : undefined;

  const [{ data, fetching: loading, error, stale }, reFetchQuery] =
    useQuery<Query>({
      query: UpsideOfferDetails,
      variables: {
        merchantId,
        location,
        ...(categoryName && { category: categoryName.toUpperCase() }),
      },
      requestPolicy: 'network-only',
      pause: paused,
    });

  return {
    offer: data?.myPartnerOffers?.upsideOfferDetails,
    loading,
    error,
    stale,
    paused,
    refetchOfferDetails: reFetchQuery,
  };
};

export default useUpsideOffersDetails;
